/**
 * Internal-login session. The short-lived RS256 access token and the rotating
 * refresh token are kept in localStorage so the session survives reloads. The
 * access token is sent as a Bearer on every API request; when it expires, the
 * refresh token silently renews it (see api client).
 */
const TOKEN_KEY = 'ts.accessToken';
const REFRESH_KEY = 'ts.refreshToken';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_KEY);
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function setSession(accessToken: string, refreshToken: string): void {
  localStorage.setItem(TOKEN_KEY, accessToken);
  localStorage.setItem(REFRESH_KEY, refreshToken);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
}
